import { css } from '@emotion/css';
import { colors } from 'constants/theme';

const promoDetailStyles = {
    wrap: css`
        background: #f2f2f2;
        min-height: 50vh;
        padding: 24px 0;
    `,
    content: css`
        background: ${colors.white};
        padding: 16px;
        width: 100%;
        margin: 0 auto;
        max-width: 1200px;
    `,
    contentInner: css`
        width: 90%;
        margin: 0 auto;
    `,
};
export default promoDetailStyles;
